// extracted by mini-css-extract-plugin
export var dropdown = "_k8-0";
export var imagePlaceholder = "_k8-2";
export var imageWrapper = "_k8-3";
export var productImage = "_k8-1";
export var truncateContainer = "_k8-4";
export var truncateText = "_k8-5";